import { render } from "./PledgeManagerInfoExplanationBoxes.vue?vue&type=template&id=4c732f69"
import script from "./PledgeManagerInfoExplanationBoxes.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoExplanationBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__